module.exports = __webpack_public_path__ + "static/media/tour search.9c3206e0.svg";